<template>

  <div class="feedback" data-view>

    <div data-reactroot="" id="content">
      <div id="router-container">
        <top-menu></top-menu>
        <message-alert></message-alert>
        <span><div id="feedback-page-container" class="content-container" style="padding-top: 60px;"><div
            id="part_1" class="title-block"><h1>Зворотний<br>зв'язок</h1></div><section class="main-column"><div
            class="inline-svg-center-block"><svg id="feedback-svg-1" class="inline-svg-illustration" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" x="0px" y="0px" viewBox="0 -25 152 106"><g id="feedback-svg-1-mountains"><path id="feedback-svg-1-mountain-2" class="st0" d="M99,61.2l18.1-25.5c2.4-3.3,7.3-3.3,9.7,0l18.1,25.5c2.8,3.9,0,9.4-4.9,9.4h-36.1
 C99,70.7,96.2,65.2,99,61.2z"></path><path id="feedback-svg-1-mountain-1" class="st1" d="M95.3,61.2L106.9,45c2.4-3.3,7.3-3.3,9.7,0l11.5,16.3c2.8,3.9,0,9.4-4.9,9.4h-23.1
 C95.4,70.7,92.5,65.2,95.3,61.2z"></path></g><path id="feedback-svg-1-tree" class="st1" d="M38.2,30.9c-0.2,0-0.5-0.1-0.7-0.1c-0.6-4.6-4-8.5-8.8-9.4C22.7,20.2,17,24,15.8,30
 c-0.2,0.9-0.2,1.8-0.2,2.7c-3.4,1.7-6,4.9-6.8,8.9c-1.3,6.6,2.8,13.1,9.3,14.8c1.1,2.8,3.4,5,6.3,6.1v8.1h7.7v-8.1
 c3.4-1.3,6.1-4.3,6.9-8.1c0.4-2,0.2-4-0.4-5.8c3.3-0.8,6-3.5,6.7-7C46.3,36.6,43.1,31.9,38.2,30.9z"></path><g
            id="feedback-svg-1-house"><polygon id="feedback-svg-1-house-frontwall" class="st2" points="61.6,70.6 23.4,70.6 23.4,48.7 26.5,43.8 60.3,43.8 61.6,48.1 	"></polygon><rect
            id="feedback-svg-1-house-sidewall" x="46.4" y="48.7" class="st3" width="15.3"
            height="21.9"></rect><g id="feedback-svg-1-house-windows"><circle class="feedback-svg-1-house-window st4" cx="34.4" cy="47.8" r="1.7" data-svg-origin="32.70000076293945 46.099998474121094" transform="matrix(1,0,0,1,0,0)" style="fill: rgb(0, 67, 165);"></circle><rect
            class="feedback-svg-1-house-window st4" x="26.1" y="63.4" width="3" height="4.7"
            data-svg-origin="26.100000381469727 63.400001525878906" transform="matrix(1,0,0,1,0,0)"
            style="fill: rgb(58, 106, 146);"></rect><rect class="feedback-svg-1-house-window st4" x="32.9"
                                                          y="63.4" width="3" height="4.7"
                                                          data-svg-origin="32.900001525878906 63.400001525878906"
                                                          transform="matrix(1,0,0,1,0,0)"
                                                          style="fill: rgb(184, 189, 105);"></rect><rect
            class="feedback-svg-1-house-window st4" x="39.6" y="63.4" width="3" height="4.7"
            data-svg-origin="39.599998474121094 63.400001525878906" transform="matrix(1,0,0,1,0,0)"
            style="fill: rgb(154, 169, 115);"></rect><rect class="feedback-svg-1-house-window st4" x="26.1"
                                                           y="56.7" width="3" height="4.7"
                                                           data-svg-origin="26.100000381469727 56.70000076293945"
                                                           transform="matrix(1,0,0,1,0,0)"
                                                           style="fill: rgb(188, 192, 104);"></rect><rect
            class="feedback-svg-1-house-window st4" x="32.9" y="56.7" width="3" height="4.7"
            data-svg-origin="32.900001525878906 56.70000076293945" transform="matrix(1,0,0,1,0,0)"
            style="fill: rgb(200, 200, 100);"></rect><rect class="feedback-svg-1-house-window st4" x="39.6"
                                                           y="56.7" width="3" height="4.7"
                                                           data-svg-origin="39.599998474121094 56.70000076293945"
                                                           transform="matrix(1,0,0,1,0,0)"
                                                           style="fill: rgb(188, 192, 104);"></rect><rect
            class="feedback-svg-1-house-window st4" x="26.1" y="52.9" width="3" height="2"
            data-svg-origin="26.100000381469727 52.900001525878906" transform="matrix(1,0,0,1,0,0)"
            style="fill: rgb(155, 170, 115);"></rect><rect class="feedback-svg-1-house-window st4" x="32.9"
                                                           y="52.9" width="3" height="2"
                                                           data-svg-origin="32.900001525878906 52.900001525878906"
                                                           transform="matrix(1,0,0,1,0,0)"
                                                           style="fill: rgb(181, 187, 106);"></rect><rect
            class="feedback-svg-1-house-window st4" x="39.6" y="52.9" width="3" height="2"
            data-svg-origin="39.599998474121094 52.900001525878906" transform="matrix(1,0,0,1,0,0)"
            style="fill: rgb(63, 109, 145);"></rect></g><rect id="feedback-svg-1-house-bottom" x="23.4"
                                                              y="69.1" class="st4" width="38.2"
                                                              height="1.5"></rect><g
            id="feedback-svg-1-house-roof"><polygon class="st5" points="30,44.8 38.5,44.8 39.4,50.2 64.9,50.2 60.3,42 24.7,42 20.2,50.2 29.1,50.2 		"></polygon><polygon
            class="st4" points="65.6,50.7 39.1,50.7 38.8,48.7 65.6,48.7 		"></polygon><polygon
            class="st4" points="19.5,50.7 29.4,50.7 29.7,48.7 19.5,48.7 		"></polygon></g></g><g
            id="feedback-svg-1-quote-area"><path id="feedback-svg-1-quote" class="st6" d="M100.2,6.8H54.1c-6.4,0-11.6,5.2-11.6,11.6v40.8c0,6.4,5.2,11.6,11.6,11.6h16.7
 c2.1,3.7,7.1,10,17.3,10.1c-3.9-3-5.5-7-6.1-10.1h18.2c6.4,0,11.6-5.2,11.6-11.6V18.3C111.7,11.9,106.6,6.8,100.2,6.8z"></path><rect
            id="feedback-svg-1-quote-text-4" x="54.1" y="24.6" class="feedback-svg-1-quote-text st4"
            width="46.1" height="3" style="opacity: 1;"></rect><rect id="feedback-svg-1-quote-text-3"
                                                                     x="54.1" y="32.8"
                                                                     class="feedback-svg-1-quote-text st4"
                                                                     width="46.1" height="3"
                                                                     style="opacity: 1;"></rect><rect
            id="feedback-svg-1-quote-text-2" x="54.1" y="40.8" class="feedback-svg-1-quote-text st4"
            width="46.1" height="3" style="opacity: 1;"></rect><rect id="feedback-svg-1-quote-text-1"
                                                                     x="54.1" y="47.9"
                                                                     class="feedback-svg-1-quote-text st4"
                                                                     width="38.4" height="3"
                                                                     style="opacity: 0.6279;"></rect></g><g
            id="feedback-svg-1-pen" data-svg-origin="91.5 0.4148862957954407"
            transform="matrix(1,0,0,1,-9.168062500000048,0)"><rect id="feedback-svg-1-pen-part-1" x="89.5" y="24.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 13.0429 88.8031)" class="st7" width="48.5" height="7.8"></rect><rect
            id="feedback-svg-1-pen-part-2" x="135.3" y="0.9"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 36.9404 98.7018)" class="st8" width="4.6"
            height="7.8"></rect><rect id="feedback-svg-1-pen-part-3" x="129.8" y="4.1"
                                      transform="matrix(0.7071 -0.7071 0.7071 0.7071 32.7388 96.9614)"
                                      class="st9" width="7.2" height="9.8"></rect><rect
            id="feedback-svg-1-pen-part-5" x="111.3" y="10.1"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 27.5731 89.5799)" class="st9" width="21.3"
            height="2.9"></rect><polygon id="feedback-svg-1-pen-part-6" class="st10"
                                         points="91.8,49.9 93.3,42.8 99.5,49.1 92.5,50.6 		"></polygon><path
            id="feedback-svg-1-pen-part-7" class="st4"
            d="M93.4,43.3l5.6,5.6l-6.5,1.4l-0.5-0.5L93.4,43.3 M93.1,42.3L91.5,50l0.9,0.9l7.7-1.6L93.1,42.3L93.1,42.3z"></path><rect
            id="feedback-svg-1-pen-part-8" x="94.4" y="35.8"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 1.0563 83.8381)" class="st11" width="14.6"
            height="9.8"></rect></g><g id="feedback-svg-1-clouds"><path id="feedback-svg-1-cloud-3" class="feedback-svg-1-cloud st12" d="M151.6,35.2c0.2-2.1-1.3-4.1-3.4-4.5c-0.1,0-0.2,0-0.3-0.1c-0.3-2.1-1.9-3.9-4.1-4.4
 c-2.8-0.6-5.5,1.2-6,4c-0.1,0.4-0.1,0.9-0.1,1.3c-1.4,0.7-2.6,2-3,3.7H151.6z" data-svg-origin="134.6999969482422 26.084604263305664" transform="matrix(0.95705,0,0,0.95705,5.784850015605372,-0.020842392489524464)"></path><path
            id="feedback-svg-1-cloud-2" class="feedback-svg-1-cloud st12" d="M27.4,16c0.2-2.1-1.3-4.1-3.4-4.5c-0.1,0-0.2,0-0.3-0.1c-0.3-2.1-1.9-3.9-4.1-4.4
 c-2.8-0.6-5.5,1.2-6,4c-0.1,0.4-0.1,0.9-0.1,1.3c-1.4,0.7-2.6,2-3,3.7H27.4z" data-svg-origin="10.5 6.884603500366211"
            transform="matrix(0.84596,0,0,0.84596,1.617331800000004,2.1410784925270185)"></path><path
            id="feedback-svg-1-cloud-1" class="feedback-svg-1-cloud st12" d="M17.5,45.3c0.2-2.1-1.3-4.1-3.4-4.5c-0.1,0-0.2,0-0.3-0.1c-0.3-2.1-1.9-3.9-4.1-4.4
 c-2.8-0.6-5.5,1.2-6,4c-0.1,0.4-0.1,0.9-0.1,1.3c-1.4,0.7-2.6,2-3,3.7H17.5z"
            data-svg-origin="0.6000008583068848 36.18460464477539"
            transform="matrix(0.80001,0,0,0.80001,0.11999246498368576,9.236199268922082)"></path></g></svg></div><p>Ця форма призначена для звернення за додатковою інформацією та не передбачає розсилку. Ця форма не повинна використовуватися для направлення інформації про побічні реакції при застосуванні лікарських засобів і медичних виробів компанії Санофі та іншої інформації медичного змісту.</p><div
            class="phone-flex-block"><p class="attention-paragraph">У разі розвитку побічної реакції Ви можете повідомити про неї за телефоном:</p><a
            class="phone-number" href="tel: + 38 050-443-34-28">+ 38 050-443-34-28</a><span
            class="phone-number-notice">(цілодобово)</span></div><p
            class="attention-paragraph">Якщо у Вас виникли питання, що стосуються стану здоров'я або призначень лікарських препаратів Санофі, Вам слід проконсультуватися з лікарем.</p>




<div class="content-feedback">

    <div class="send-message" v-if="sendMessage" style="text-align: left">
        Лист відправлено успішно.
    </div>

    <div class="form-wrapper" v-if="sendMessage === false">

        <div class="content-wrapper">

            <div class="left">

                <div class="title">Представтесь, будь ласка</div>

                <div class="item-wrapper">
                    <p>* Прізвище</p>
                    <input type="text" v-model="data.surName">
                </div>

                <div class="item-wrapper">
                    <p>* Ім’я</p>
                    <input type="text" v-model="data.name">
                </div>

                <div class="item-wrapper">
                    <p>Організація і посада</p>
                    <input type="text" v-model="data.organization">
                </div>

                <div class="item-wrapper">

                    <div class="item">
                        <input @click="check('consumer')" type="radio" name="q1" id="q1">
                        <label for="q1">Споживач</label>
                    </div>

                    <div class="item">
                        <input @click="check('medical')" type="radio" name="q1" id="q2">
                        <label for="q2">Медичний працівник</label>
                    </div>

                    <div class="item">
                        <input @click="check('journalist')" type="radio" name="q1" id="q3">
                        <label for="q3">Журналіст</label>
                    </div>
                </div>

                <div class="title">Повідомлення</div>

                <div class="item-wrapper">
                    <p>Тема повідомлення</p>
                    <input type="text" v-model="data.theme">
                </div>

                <div class="item-wrapper">
                    <p>* Повідомлення</p>
                    <textarea v-model="data.message"></textarea>
                </div>

            </div>

            <div class="right">

                <div class="title">Контактна інформація</div>

                <div class="item-wrapper">
                    <p>* Email</p>
                    <input type="text" v-model="data.email">
                </div>

                <div class="item-wrapper">
                    <p>Країна</p>
                    <input type="text" v-model="data.country">
                </div>

                <div class="item-wrapper">
                    <p>Місто</p>
                    <input type="text" v-model="data.city">
                </div>

                <div class="item-wrapper">
                    <p>Індекс</p>
                    <input type="text" v-model="data.index">
                </div>

                <div class="item-wrapper">
                    <p>Адреса</p>
                    <input type="text" v-model="data.address">
                </div>

                <div class="item-wrapper">
                    <p>* Телефон</p>
                    <input type="text" id="phone"
                           v-model="data.phone"
                           placeholder="(___) ___-__-__">
                </div>

            </div>
        </div>

        <div class="bottom">

            <div class="item-wrapper">
                 <vue-recaptcha
                     ref="recaptcha"
                     size="invisible"
                     :sitekey="sitekey"
                     @verify="register"
                     @expired="onCaptchaExpired"
                 />
            </div>

            <div class="item-wrapper">
                <p>
                    * поля, обов’язкові для заповнення<br>

                    Інформація про конфіденційність<br>

                  Натискаючи кнопку «Надіслати», Ви надаєте свою однозначну згоду на обробку компанією ТОВ «Опелла Хелскеа Україна» (вул. Жилянська, 48-50а, м. Київ 01033, Україна) в якості володільця наданих Вами в формі персональних даних з метою надання відповіді на Ваше повідомлення і ведення внутрішньої звітності. Санофі зобов'язується зберігати конфіденційність переданих Вами повідомлень і не буде передавати їх будь-яким третім особам поза Групою компаній «Санофі». Передача даних іншим компаніям Групи «Санофі» включає їх передачу за кордон і здійснюється за умови забезпечення належного захисту Ваших даних. Адреса електронної пошти та інша інформація, зазначена Вами в формі, буде використана виключно для надання відповіді на повідомлення. Санофі не використовуватиме вказані Вами дані для розсилки матеріалів і інформації, що не запитувалися. Ви також підтверджуєте, що ознайомилися з Вашими правами в сфері персональних даних, які для Вашої зручності викладені в <router-link to="/official-notice">Офіційному повідомленні</router-link>. Ви погоджуєтеся з тим, що зміна, видалення або знищення Ваших персональних даних або обмеження доступу до них не потребують будь-якого додаткового повідомлення Вам про такі дії.
                </p>
              <p>
                В <router-link to="/official-notice">Офіційному повідомленні</router-link> Ви знайдете додаткову інформацію щодо правил та умов, що застосовуються до всіх відвідувачів цього сайту.
              </p>
            </div>

            <div class="error-message" v-show="error" style="color: red; text-align: left !important;">
                Форма заповнена неправильно
            </div>

            <div class="btn-group" id="unique_class" >
                <p>Надіслати</p>
            </div>
        </div>


    </div>
</div>

                    <p
                        class="attention-paragraph">Ви отримаєте відповідь на своє повідомлення найближчим часом. Дякуємо Вам за інтерес до нашої компанії. Після успішного відправлення форми Вам буде вислано лист з підтвердженням.</p></section><div
            class="bottom-note-block"><p class="footnote"><sup>1</sup> Формула оновлена за рахунок збільшення вмісту ліпази (на 3 000 МО) та α-амілази (на 2 500 МО) порівняно із Фестал<sup>®</sup> НЕО (РП МОЗ України № UA / 11255/01/02 (втратило чинність 06.01.2016 року). Наказ МОЗ України № 905 від 01.12.2014. Зміни до реєстраційного посвідчення затверджені Наказом МОЗ України № 616 від 03.09.14.). Інструкція для медичного застосування препарату Фестал<sup>®</sup>&nbsp;НЕО&nbsp;10&nbsp;000. Наказ МОЗ України №462 от 24.07.2015.<br><sup>2</sup>  Панкреатин – фермент підшлункової залози, що сприяє травленню. Показання: Для поліпшення перетравлювання їжі особам з нормальною функцією шлунково-кишкового тракту в разі порушень режиму раціонального харчування (важкість у шлунку). Метеоризм.<br><sup>3</sup> До складу препарату входять основні панкреатичні травні ферменти: ліпаза, α-амілаза, протеази (трипсин і хімотрипсин), які чинять ліполітичну, амілолітичну і протеолітичну дію.</p><p
            class="adversting-text">Реклама лікарського засобу. Перед застосуванням лікарського засобу необхідно проконсультуватися з лікарем та обов’язково ознайомитися з інструкцією для медичного застосування препарату Фестал<sup>®</sup>&nbsp;НЕО&nbsp;10&nbsp;000. Зберігати у недоступному для дітей місці.</p><table
            class="adversting-text-table"><tbody><tr class="top-line"><td>

        </td><td>
<!--          <router-link to="/feedback">Зворотний зв'язок</router-link>-->
          .</td></tr><tr
            class="bottom-line"><td> <router-link to="/official-notice">Офіційне повідомлення</router-link>.<br>Всі права захищені<sup>®</sup> 2021. Дата останнього перегляду 09.03.2021. Сайт призначений виключно для відвідувачів з України.</td><td>ТОВ «Опелла Хелскеа Україна», Київ, 01033, вул. Жилянська, 48‒50а, тел.: +38 (044) 354 20 00, факс: +38 (044) 354 20 01, <a
            href="http://www.sanofi.ua" style="padding-right: 5px; display: inline-block;" target="_blank">www.sanofi.ua</a><a
            href="http://www.festal.ua" target="_blank">www.festal.ua</a> MAT-UA-2100059-1.0-02/2021</td><td><router-link
            to="/instruction" class="non-line">Інструкція для медичного застосування препарату Фестал<sup>®</sup>&nbsp;НЕО&nbsp;10&nbsp;000, таблетки, вкриті оболонкою, кишковорозчинні.
																																												</router-link><br>РП №UA/14533/01/01. Наказ МОЗ України  №1994 від 21.09.2021.</td></tr></tbody></table></div><footer
            id="self-medication-block"><div class="word"><div class="letter s"></div><div
            class="letter a"></div><div class="letter m bigger-letter"></div><div class="letter o"></div><div
            class="letter l"></div><div class="letter i smaller-letter"></div><div class="letter k"></div><div
            class="letter u"></div><div class="letter v"></div><div class="letter a"></div><div
            class="letter n"></div><div class="letter n"></div><div class="letter ia"></div></div><div
            class="word"><div class="letter m bigger-letter"></div><div class="letter o"></div><div
            class="letter ge bigger-letter"></div><div class="letter e"></div></div><div class="word"><div
            class="letter b"></div><div class="letter u"></div><div class="letter t"></div><div
            class="letter ii"></div></div><div class="word"><div class="letter sh bigger-letter"></div><div
            class="letter k"></div><div class="letter i smaller-letter"></div><div class="letter d"></div><div
            class="letter l"></div><div class="letter ii"></div><div class="letter v"></div><div
            class="letter ii"></div><div class="letter m bigger-letter"></div></div><div class="word"><div
            class="letter d"></div><div class="letter l"></div><div class="letter ia"></div></div><div
            class="word"><div class="letter v"></div><div class="letter a"></div><div
            class="letter sh bigger-letter"></div><div class="letter o"></div><div class="letter g"></div><div
            class="letter o"></div></div><div class="word"><div class="letter z"></div><div
            class="letter d"></div><div class="letter o"></div><div class="letter r"></div><div
            class="letter o"></div><div class="letter v"></div><div
            class="letter znak smaller-letter"></div><div class="letter ia"></div></div><svg
            id="self-medication-svg" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" x="0px" y="0px"
            viewBox="0 0 568.5 58.4"><g id="self-medication-svg-letters"><path class="self-medication-svg-letter" d="M8.8,17.2c0-5,1.3-7.9,4.8-7.9c3.5,0,4.8,2.9,4.8,7.9V18c0,0-0.1,0.2-0.2,0.2S18,18,18,18v-0.8
 c0-4.4-1.1-6.8-4.4-6.8c-3.3,0-4.3,2.4-4.3,6.8v23.2c0,4.4,1.1,6.8,4.3,6.8c3,0,4.6-2.5,4.6-2.5s0.1,0.2,0.1,0.6
 c0,0.3-0.1,0.6-0.1,0.6s-1.3,2.5-4.6,2.5c-3.5,0-4.8-2.9-4.8-7.9V17.2z"></path><path class="self-medication-svg-letter"
                                                                                    d="M24.1,9.5c0,0,0.1-0.2,0.3-0.2c0.2,0,0.3,0.2,0.3,0.2L30,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2
 l-1.7-12h-6.9l-1.7,12c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2L24.1,9.5z M21.1,34.8h6.6l-3.3-24.2L21.1,34.8z"></path><path
            class="self-medication-svg-letter" d="M43.3,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V12.1l-5.5,29c0,0-0.1,0.2-0.3,0.2s-0.3-0.2-0.3-0.2
 l-5.4-28.9V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V9.6c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2l5.7,30.5l5.8-30.6
 c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48z"></path><path class="self-medication-svg-letter" d="M45.4,17.2c0-5,1.4-7.9,4.9-7.9c3.5,0,4.9,2.9,4.9,7.9v23.2c0,5-1.4,7.9-4.9,7.9c-3.5,0-4.9-2.9-4.9-7.9V17.2z
 M45.9,40.4c0,4.4,1.2,6.8,4.5,6.8c3.3,0,4.5-2.4,4.5-6.8V17.2c0-4.4-1.2-6.8-4.5-6.8c-3.3,0-4.5,2.4-4.5,6.8V40.4z"></path><path
            class="self-medication-svg-letter" d="M60.1,9.7c0,0,1.3-0.3,3.4-0.3c2.1,0,3.5,0.3,3.5,0.3V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V10.5
 h-6.1l-1.6,29.8c-0.3,5-0.7,7.9-2.7,7.9c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6c1.7,0,2-2.4,2.2-6.8L60.1,9.7z"></path><path
            class="self-medication-svg-letter" d="M70,47V10.5h-1.9c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6h4.2c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6
 h-1.9V47h1.9c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6h-4.2c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6H70z"></path><path
            class="self-medication-svg-letter" d="M76.2,28.5L74,30.1V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2
 c0.1,0,0.2,0.2,0.2,0.2V29l2.2-1.7l4.9-17.8c0,0,0.1-0.2,0.3-0.2c0.2,0,0.3,0.2,0.3,0.2l-5.1,18.4l5.3,20c0,0-0.1,0.2-0.3,0.2
 c-0.1,0-0.3-0.2-0.3-0.2L76.2,28.5z"></path><path class="self-medication-svg-letter" d="M87,37c0,0-0.1-0.1-0.1-0.1L82,9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2l4.7,26.4l4.6-26.4
 c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2L86.6,42c-0.7,3.9-1.4,6.2-2.9,6.2c-0.6,0-0.9-0.2-0.9-0.2s-0.1-0.2-0.1-0.6
 s0.1-0.6,0.1-0.6s0.3,0.2,0.9,0.2c1.3,0,2-2,2.5-5.1L87,37z"></path><path class="self-medication-svg-letter" d="M93.2,9.5c0,0,1.8-0.3,4.4-0.3c3,0,4.3,3.1,4.3,8.5v2.5c0,4.1-0.8,6.9-2.5,8c2,1,2.8,3.9,2.8,8.1v3.3
 c0,5.4-1.3,8.7-4.6,8.7c-2.6,0-4.4-0.3-4.4-0.3V9.5z M93.7,27.7h4c2.8,0,3.9-2.5,3.9-7.4v-2.5c0-4.9-1-7.4-3.9-7.4h-4V27.7z
 M93.7,47.1h4c3.1,0,4.2-2.6,4.2-7.6v-3.3c0-5-1.1-7.6-4.2-7.6h-4V47.1z"></path><path class="self-medication-svg-letter"
                                                                                    d="M107.8,9.5c0,0,0.1-0.2,0.3-0.2c0.2,0,0.3,0.2,0.3,0.2l5.3,38.4c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2
 l-1.7-12h-6.9L103,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2L107.8,9.5z M104.8,34.8h6.6l-3.3-24.2L104.8,34.8z"></path><path
            class="self-medication-svg-letter" d="M124.3,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V28.8h-8.8V48c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2s0.2,0.2,0.2,0.2v18.1h8.8V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48z"></path><path
            class="self-medication-svg-letter" d="M135.9,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V28.8h-8.8V48c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2s0.2,0.2,0.2,0.2v18.1h8.8V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48z"></path><path
            class="self-medication-svg-letter" d="M146.4,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V29.9c0,0-1.7,0.2-4,0.2h-0.1L137.7,48
 c0,0-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.3-0.2l4.2-17.9c-2.8-0.3-3.9-3.4-3.9-8.4v-4c0-5.3,1.3-8.4,4.5-8.4c2.6,0,4.4,0.3,4.4,0.3
 V48z M146,10.4h-4c-3,0-4.1,2.5-4.1,7.3v4c0,4.8,1.1,7.3,4.1,7.3h4V10.4z"></path><path class="self-medication-svg-letter"
                                                                                      d="M166.1,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V12.1l-5.5,29c0,0-0.1,0.2-0.3,0.2
 c-0.2,0-0.3-0.2-0.3-0.2l-5.4-28.9V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V9.6c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2
 l5.7,30.5l5.8-30.6c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48z"></path><path class="self-medication-svg-letter" d="M168.3,17.2c0-5,1.4-7.9,4.9-7.9c3.5,0,4.9,2.9,4.9,7.9v23.2c0,5-1.4,7.9-4.9,7.9c-3.5,0-4.9-2.9-4.9-7.9V17.2
 z M168.7,40.4c0,4.4,1.2,6.8,4.5,6.8c3.3,0,4.5-2.4,4.5-6.8V17.2c0-4.4-1.2-6.8-4.5-6.8c-3.3,0-4.5,2.4-4.5,6.8V40.4z"></path><path
            class="self-medication-svg-letter" d="M179.1,48c0,0-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.3-0.2l4.5-20.2l-4.2-18.2c0,0,0.1-0.2,0.3-0.2
 c0.2,0,0.3,0.2,0.3,0.2l4.1,17.7l2.1,1.7V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2v19.3l2.1-1.7l4.1-17.7
 c0,0,0.1-0.2,0.3-0.2c0.2,0,0.3,0.2,0.3,0.2l-4.2,18.2l4.5,20.2c0,0-0.1,0.2-0.3,0.2c-0.1,0-0.3-0.2-0.3-0.2L188,28.3l-2.1,1.7v18
 c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V30l-2.1-1.7L179.1,48z"></path><path class="self-medication-svg-letter" d="M194.2,47h8.1c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6h-4.5c-2.4,0-4-0.3-4-0.3V9.7c0,0,1.6-0.3,4-0.3h4.4
 c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6h-8v17.1h7.2c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6h-7.2V47z"></path><path
            class="self-medication-svg-letter" d="M209.5,26.8c0,0,1.7-0.2,4-0.2c3.2,0,4.5,3.1,4.5,8.4v4.8c0,5.3-1.3,8.4-4.5,8.4c-2.6,0-4.4-0.3-4.4-0.3V9.7
 c0,0,1.6-0.3,4-0.3h4.3c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6h-7.9V26.8z M209.5,47.1h4c3,0,4.1-2.5,4.1-7.3V35
 c0-4.8-1.1-7.3-4.1-7.3h-4V47.1z"></path><path class="self-medication-svg-letter" d="M223.5,37c0,0-0.1-0.1-0.1-0.1l-4.9-27.4c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2l4.7,26.4l4.6-26.4
 c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2L223.1,42c-0.7,3.9-1.4,6.2-2.9,6.2c-0.6,0-0.9-0.2-0.9-0.2s-0.1-0.2-0.1-0.6
 s0.1-0.6,0.1-0.6s0.3,0.2,0.9,0.2c1.3,0,2-2,2.5-5.1L223.5,37z"></path><path class="self-medication-svg-letter" d="M234.1,10.5V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V10.5h-4.8c0,0-0.1-0.2-0.1-0.6
 c0-0.3,0.1-0.6,0.1-0.6h9.8c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6H234.1z"></path><path
            class="self-medication-svg-letter" d="M249.8,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V11.5L240.4,48c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V46l8.9-36.4c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48
 z"></path><path class="self-medication-svg-letter" d="M272.1,9.5v38.3c0,0-1.5,0.3-3.9,0.3h-7.1c-2.4,0-4-0.3-4-0.3V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2
 V47h6.9V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V47h6.9V9.5c0,0,0.1-0.2,0.2-0.2C272.1,9.4,272.1,9.5,272.1,9.5"></path><path
            class="self-medication-svg-letter" d="M276.7,28.5l-2.2,1.7V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2
 c0.1,0,0.2,0.2,0.2,0.2V29l2.2-1.7l4.9-17.8c0,0,0.1-0.2,0.3-0.2c0.2,0,0.3,0.2,0.3,0.2l-5.1,18.4l5.3,20c0,0-0.1,0.2-0.3,0.2
 c-0.1,0-0.3-0.2-0.3-0.2L276.7,28.5z"></path><path class="self-medication-svg-letter" d="M284.4,47V10.5h-1.9c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6h4.2c0,0,0.1,0.2,0.1,0.6
 c0,0.3-0.1,0.6-0.1,0.6h-1.9V47h1.9c0,0,0.1,0.2,0.1,0.6c0,0.3-0.1,0.6-0.1,0.6h-4.2c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6
 H284.4z"></path><path class="self-medication-svg-letter" d="M287.1,47.1c1.8,0,2.1-2.3,2.3-6.8L291,9.7c0,0,1.3-0.3,3.4-0.3c2.1,0,3.5,0.3,3.5,0.3V47
 c1.1,0,1.8,0.2,1.8,0.2v9.1c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2v-8.2h-11.8v8.2c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V47.1z M297.4,47V10.5h-6.1l-1.6,29.8c-0.2,3.1-0.4,5.4-1.1,6.6H297.4z"></path><path
            class="self-medication-svg-letter" d="M303.9,9.7c0,0,1.3-0.3,3.4-0.3c2.1,0,3.5,0.3,3.5,0.3V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V10.5
 h-6.1l-1.6,29.8c-0.3,5-0.7,7.9-2.7,7.9c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6c1.7,0,2-2.4,2.2-6.8L303.9,9.7z"></path><path
            class="self-medication-svg-letter" d="M322.4,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V11.5L313.1,48c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V46L322,9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48z
 "></path><path class="self-medication-svg-letter" d="M324.4,9.5c0,0,1.8-0.3,4.4-0.3c3,0,4.3,3.1,4.3,8.5v2.5c0,4.1-0.8,6.9-2.5,8c2,1,2.8,3.9,2.8,8.1v3.3
 c0,5.4-1.3,8.7-4.6,8.7c-2.6,0-4.4-0.3-4.4-0.3V9.5z M324.8,27.7h4c2.8,0,3.9-2.5,3.9-7.4v-2.5c0-4.9-1-7.4-3.9-7.4h-4V27.7z
 M324.8,47.1h4c3.1,0,4.2-2.6,4.2-7.6v-3.3c0-5-1.1-7.6-4.2-7.6h-4V47.1z"></path><path class="self-medication-svg-letter"
                                                                                     d="M344.7,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V11.5L335.4,48c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V46l8.9-36.4c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V48
 z"></path><path class="self-medication-svg-letter" d="M359.1,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V12.1l-5.5,29c0,0-0.1,0.2-0.3,0.2s-0.3-0.2-0.3-0.2
 l-5.4-28.9V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V9.6c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2l5.7,30.5l5.8-30.6
 c0,0,0.1-0.2,0.2-0.2s0.2,0.2,0.2,0.2V48z"></path><path class="self-medication-svg-letter" d="M366.5,47.1c1.8,0,2.1-2.3,2.3-6.8l1.7-30.7c0,0,1.3-0.3,3.4-0.3c2.1,0,3.5,0.3,3.5,0.3V47
 c1.1,0,1.8,0.2,1.8,0.2v9.1c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2v-8.2H367v8.2c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2
 V47.1z M376.9,47V10.5h-6.1l-1.6,29.8c-0.2,3.1-0.4,5.4-1.1,6.6H376.9z"></path><path class="self-medication-svg-letter"
                                                                                    d="M383.3,9.7c0,0,1.3-0.3,3.4-0.3c2.1,0,3.5,0.3,3.5,0.3V48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V10.5
 h-6.1l-1.6,29.8c-0.3,5-0.7,7.9-2.7,7.9c0,0-0.1-0.2-0.1-0.6c0-0.3,0.1-0.6,0.1-0.6c1.7,0,2-2.4,2.2-6.8L383.3,9.7z"></path><path
            class="self-medication-svg-letter" d="M400.7,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V29.9c0,0-1.7,0.2-4,0.2h-0.1L392,48
 c0,0-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.3-0.2l4.2-17.9c-2.8-0.3-3.9-3.4-3.9-8.4v-4c0-5.3,1.3-8.4,4.5-8.4c2.6,0,4.4,0.3,4.4,0.3
 V48z M400.3,10.4h-4c-3,0-4.1,2.5-4.1,7.3v4c0,4.8,1.1,7.3,4.1,7.3h4V10.4z"></path><path
            class="self-medication-svg-letter" d="M405.2,9.5c0,0,1.8-0.3,4.4-0.3c3,0,4.3,3.1,4.3,8.5v2.5c0,4.1-0.8,6.9-2.5,8c2,1,2.8,3.9,2.8,8.1v3.3
 c0,5.4-1.3,8.7-4.6,8.7c-2.6,0-4.4-0.3-4.4-0.3V9.5z M405.6,27.7h4c2.8,0,3.9-2.5,3.9-7.4v-2.5c0-4.9-1-7.4-3.9-7.4h-4V27.7z
 M405.6,47.1h4c3.1,0,4.2-2.6,4.2-7.6v-3.3c0-5-1.1-7.6-4.2-7.6h-4V47.1z"></path><path class="self-medication-svg-letter"
                                                                                     d="M419.8,9.5c0,0,0.1-0.2,0.3-0.2c0.2,0,0.3,0.2,0.3,0.2l5.3,38.4c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2
 l-1.7-12h-6.9L415,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2L419.8,9.5z M416.8,34.8h6.6l-3.3-24.2L416.8,34.8z"></path><path
            class="self-medication-svg-letter" d="M441.6,9.5v38.3c0,0-1.5,0.3-3.9,0.3h-7.1c-2.4,0-4-0.3-4-0.3V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2
 V47h6.9V9.5c0,0,0.1-0.2,0.2-0.2c0.1,0,0.2,0.2,0.2,0.2V47h6.9V9.5c0,0,0.1-0.2,0.2-0.2C441.6,9.4,441.6,9.5,441.6,9.5"></path><path
            class="self-medication-svg-letter" d="M443.6,17.2c0-5,1.4-7.9,4.9-7.9c3.5,0,4.9,2.9,4.9,7.9v23.2c0,5-1.4,7.9-4.9,7.9c-3.5,0-4.9-2.9-4.9-7.9V17.2
 z M444,40.4c0,4.4,1.2,6.8,4.5,6.8c3.3,0,4.5-2.4,4.5-6.8V17.2c0-4.4-1.2-6.8-4.5-6.8c-3.3,0-4.5,2.4-4.5,6.8V40.4z"></path><path
            class="self-medication-svg-letter" d="M455.8,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V9.7c0,0,1.6-0.3,4-0.3h3.7c0,0,0.1,0.2,0.1,0.6
 c0,0.3-0.1,0.6-0.1,0.6h-7.2V48z"></path><path class="self-medication-svg-letter" d="M463.9,17.2c0-5,1.4-7.9,4.9-7.9c3.5,0,4.9,2.9,4.9,7.9v23.2c0,5-1.4,7.9-4.9,7.9c-3.5,0-4.9-2.9-4.9-7.9V17.2
 z M464.3,40.4c0,4.4,1.2,6.8,4.5,6.8s4.5-2.4,4.5-6.8V17.2c0-4.4-1.2-6.8-4.5-6.8s-4.5,2.4-4.5,6.8V40.4z"></path><path
            class="self-medication-svg-letter" d="M489.5,17.8v2.5c0,4.1-0.8,6.9-2.5,8c2,1,2.8,3.9,2.8,8.1v3.3c0,5.4-1.3,8.7-4.5,8.7c-3.2,0-4.5-2.5-4.5-2.5
 s-0.1-0.2-0.1-0.6c0-0.4,0.1-0.6,0.1-0.6s1.5,2.5,4.5,2.5s4.1-2.6,4.1-7.6v-3.3c0-5-1.1-7.6-4.2-7.6h-1.8c0,0-0.1-0.2-0.1-0.6
 c0-0.3,0.1-0.6,0.1-0.6h1.8c2.8,0,3.9-2.5,3.9-7.4v-2.5c0-4.9-1-7.4-3.8-7.4c-3.2,0-4.2,2.4-4.2,6.8V18c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2v-0.8c0-5,1.3-7.9,4.7-7.9C488.3,9.3,489.5,12.4,489.5,17.8"></path><path
            class="self-medication-svg-letter" d="M490.3,47.1c1.8,0,2.1-2.3,2.3-6.8l1.7-30.7c0,0,1.3-0.3,3.4-0.3c2.1,0,3.5,0.3,3.5,0.3V47
 c1.1,0,1.8,0.2,1.8,0.2v9.1c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2v-8.2h-11.8v8.2c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V47.1z M500.7,47V10.5h-6.1L493,40.4c-0.2,3.1-0.4,5.4-1.1,6.6H500.7z"></path><path
            class="self-medication-svg-letter" d="M504,17.2c0-5,1.4-7.9,4.9-7.9c3.5,0,4.9,2.9,4.9,7.9v23.2c0,5-1.4,7.9-4.9,7.9c-3.5,0-4.9-2.9-4.9-7.9V17.2z
 M504.4,40.4c0,4.4,1.2,6.8,4.5,6.8c3.3,0,4.5-2.4,4.5-6.8V17.2c0-4.4-1.2-6.8-4.5-6.8c-3.3,0-4.5,2.4-4.5,6.8V40.4z"></path><path
            class="self-medication-svg-letter" d="M520,9.3c3.2,0,4.5,2.9,4.5,7.9V22c0,5-1.3,7.9-4.5,7.9c-2.3,0-3.8-0.2-3.8-0.2V48c0,0-0.1,0.2-0.2,0.2
 c-0.1,0-0.2-0.2-0.2-0.2V9.5C515.8,9.5,517.5,9.3,520,9.3 M516.2,28.8h3.8c3,0,4.1-2.4,4.1-6.8v-4.8c0-4.4-1.1-6.8-4.1-6.8h-3.8
 V28.8z"></path><path class="self-medication-svg-letter" d="M526.3,17.2c0-5,1.4-7.9,4.9-7.9c3.5,0,4.9,2.9,4.9,7.9v23.2c0,5-1.4,7.9-4.9,7.9c-3.5,0-4.9-2.9-4.9-7.9V17.2
 z M526.8,40.4c0,4.4,1.2,6.8,4.5,6.8s4.5-2.4,4.5-6.8V17.2c0-4.4-1.2-6.8-4.5-6.8s-4.5,2.4-4.5,6.8V40.4z"></path><path
            class="self-medication-svg-letter" d="M538.1,9.5c0,0,1.8-0.3,4.4-0.3c3,0,4.3,3.1,4.3,8.5v2.5c0,4.1-0.8,6.9-2.5,8c2,1,2.8,3.9,2.8,8.1v3.3
 c0,5.4-1.3,8.7-4.6,8.7c-2.6,0-4.4-0.3-4.4-0.3V9.5z M538.6,27.7h4c2.8,0,3.9-2.5,3.9-7.4v-2.5c0-4.9-1-7.4-3.9-7.4h-4V27.7z
 M538.6,47.1h4c3.1,0,4.2-2.6,4.2-7.6v-3.3c0-5-1.1-7.6-4.2-7.6h-4V47.1z"></path><path class="self-medication-svg-letter"
                                                                                     d="M548.1,18.7c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2s1.1-2.7,1.1-9.2c0,0,0.1-0.2,0.2-0.2
 c0.1,0,0.2,0.2,0.2,0.2C549.2,16.3,548.1,18.7,548.1,18.7"></path><path class="self-medication-svg-letter" d="M559.7,48c0,0-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.2-0.2-0.2V29.9c0,0-1.7,0.2-4,0.2h-0.1L551,48
 c0,0-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.3-0.2l4.2-17.9c-2.8-0.3-3.9-3.4-3.9-8.4v-4c0-5.3,1.3-8.4,4.5-8.4c2.6,0,4.4,0.3,4.4,0.3
 V48z M559.3,10.4h-4c-3,0-4.1,2.5-4.1,7.3v4c0,4.8,1.1,7.3,4.1,7.3h4V10.4z"></path></g></svg></footer></div></span></div>
    </div>
  </div>
</template>


<script>
import actualPaddingSetter from '../modules/actualPaddingSetter';
import feedbackSvgAnimate from '../modules/svg_animation/feedbackSvgAnimate';
import VueRecaptcha from 'vue-recaptcha'


export default {
  name: "feedback",
  components: { VueRecaptcha },
  data: () => ({

    email: null,
    password: null,
    sitekey: '6Lcx3lgaAAAAAAMzmKFXiFsHs2LwAKI-KsIhKnnl',

    error: false,
    sendMessage: false,

    data: {
      surName: "",
      name: "",
      organization: "",
      type: "",

      theme: "",
      message: "",

      email: "",
      country: "",
      city: "",
      index: "",
      address: "",

      phone: "",
    }
  }),
  mounted() {

    let trigger25 = true;
    let trigger50 = true;
    let trigger75 = true;
    let trigger90 = true;

    window.addEventListener("scroll", () => {

          var h = document.documentElement,
              b = document.body,
              st = 'scrollTop',
              sh = 'scrollHeight';

          var percent = parseInt((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);
          if (percent >= 25 && percent < 50 && trigger25) {
            trigger25 = false
            dataLayer.push({
              'event': 'click',
              'event_category': 'скрол сторінки 25%',
              'event_label': 'UA: ' + this.$route.path
            })
          } else if (percent >= 50 && percent < 75 && trigger50) {
            trigger50 = false
            dataLayer.push({
              'event': 'click',
              'event_category': 'скрол  сторінки 50%',
              'event_label': 'UA: ' + this.$route.path
            })
          } else if (percent >= 75 && percent < 90 && trigger75) {
            trigger75 = false
            dataLayer.push({
              'event': 'click',
              'event_category': 'скрол  сторінки 75%',
              'event_label': 'UA: ' + this.$route.path
            })
          } else if (percent >= 90 && trigger90) {
            trigger90 = false
            dataLayer.push({
              'event': 'click',
              'event_category': 'скрол  сторінки 90%',
              'event_label': 'UA: ' + this.$route.path
            })
          }
    })

    feedbackSvgAnimate();
    actualPaddingSetter();
    $('#phone').mask('0000000000');
    document.getElementById('unique_class').addEventListener('click', () => {
      this.validate();
    })

  },
  methods: {

    register (recaptchaToken) {
      this.send();
    },

    validate () {
      // тут можно добавить проверку на валидацию
      // например, с помощью vee validate
      // если с валидацией наших полей все хорошо, запускаем каптчу
      this.$refs.recaptcha.execute()
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    check(value) {
      this.data.type = value;
    },
    send() {
      if (
          this.surName !== "" &&
          this.name !== "" &&
          this.message !== "" &&
          this.ValidateEmail(this.data.email) &&
          this.data.phone.length === 10 &&
          this.data.phone !== ''
      ) {
        this.doMail();
        this.error = false;
      } else {
        this.error = true;
      }
    },
    doMail() {
      var sendToMail = "Reception-A.Ukraine@sanofi.com";
      var sendToName = "Sanofi";
      var subject = "CHC feedback";

      var data = {
        surName: this.data.surName,
        name: this.data.name,
        organization: this.data.organization,
        type: this.data.type,

        theme: this.data.theme,
        message: this.data.message,

        email: this.data.email,
        country: this.data.country,
        city: this.data.city,
        index: this.data.index,
        address: this.data.address,

        phone: this.data.phone,
        site: "festal / ukr",
      }
      var template_id = "d-690c42686689431697c057a97fd748dd"
      this.sendMail(sendToMail, sendToName, subject, data, template_id)
          .then((res) => {
            console.log(res);
            sessionStorage.clear();
            this.sendMessage = true;
          })
    },

    async sendMail(sendToMail, sendToName, subject, data, template_id) {
        var res = 0;
        fetch('https://connector-stage.azurewebsites.net/api/mail/post', {
            method:'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                MailId : 12 ,
                Data : "{'data':{'surName':'"+ data.surName +"', 'name':'"+ data.name +"', 'organization':'"+ data.organization +"', 'type': '"+ data.type +"', 'theme':'" + data.theme + "', 'message':'" + data.message + "', 'email': '"+ data.email +"', 'country': '"+ data.country +"', 'city':'"+ data.city +"', 'index':'"+ data.index +"', 'address':'"+ data.address +"', 'phone': '"+ data.phone +"', 'site':'festal / ukr' }}"
            })
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            res = response;
        })
      return res;

    },
    ValidateEmail(mail) {
      if (/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(mail)) {

        return (true)
      }
      return (false)
    },
  }
}
</script>
<style lang="less">
body {
  text-align: left !important;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
}

.left {
  max-width: 100%;
  width: 100%;
  margin-right: 0;
}

.right {
  max-width: 100%;
  width: 100%;
  margin-left: 0;
}

.title {
  margin-bottom: 30px;
  font-size: 1.4rem;
  font-weight: 400;
}


.form-wrapper * {
  font-family: sans-serif;
}

.form-wrapper {
  padding: 20px;

}

.item-wrapper {
  margin-bottom: 20px;
}

.item-wrapper p {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;


  margin: 0 0 .5rem 0 !important;
  text-indent: 0 !important;
}

label {
  margin-left: 10px;
}

.item-wrapper .item {
  margin-bottom: 10px;
  text-align: left !important;
}

.item-wrapper .item:last-child {
  margin-bottom: 0;
}

input[type=text] {
  width: 100%;

  display: block;
  height: calc(2.25rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

select {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

textarea {
  display: block;
  width: 100%;
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  height: auto;
  overflow: auto;
  resize: vertical;
}

.btn-group {
  background-color: #28a745;

  display: flex;
  justify-content: center;
  align-items: center;

  max-width: 100px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;


  transition: all 0.2s ease;
}

.btn-group:hover {
  background-color: #1c8532;
}

.btn-group p {
  color: #fff;
  margin: 0 !important;
  text-indent: 0 !important;
}
</style>
